var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 21,
    viewBox: "0 0 16 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.96571 10.2034C10.2795 10.2034 12.1761 7.92758 12.1761 5.08276C12.1761 2.23793 11.5692 0 7.96571 0C4.36227 0 3.75537 2.27586 3.75537 5.12069C3.75537 7.96552 5.65192 10.2034 7.96571 10.2034Z",
    fill: "#467599"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8933 18.131C15.9312 18.0931 15.9312 17.8276 15.8933 18.131V18.131Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8931 17.7897C15.8172 12.8586 15.1724 11.4931 10.2414 10.5828C10.2414 10.5828 9.55862 11.4552 7.92759 11.4552C6.33448 11.4552 5.61379 10.5828 5.61379 10.5828C0.75862 11.4552 0.0758621 12.8586 0 17.6379C0 18.0172 0 18.0552 0 18.0172V18.5483C0 18.5483 1.17586 20.9 7.92759 20.9C14.6793 20.9 15.8552 18.5483 15.8552 18.5483V18.169C15.8931 18.169 15.8931 18.0931 15.8931 17.7897Z",
    fill: "#193051"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.6c002a842f6b10aa0bd664c17f5888ba.svg";
export { ForwardRef as ReactComponent };